/**************************************************
 * Nombre:       Formulario_Programa_Perfil
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Informacion from "../../Tarjeta/Tarjetas_Informacion";
import Formulario_Programa_Perfil_Perfil from "./Formulario_Programa_Perfil_Perfil";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Programa_Perfil = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Perfil',
        dato: 'perfiles',
        Tarjeta: Tarjetas_Informacion,
        Formulario: Formulario_Programa_Perfil_Perfil,
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Parrafo corto justificacion del perfil'}
                                  dato={'perfil'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Agregar Items del perfil del egresado</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa_Perfil